export default __webpack_public_path__ + "static/5-98f6bbdcd61e9b01740d65b38dec5111.jpg";